import React,{useEffect} from "react";
import { JWTBuilder } from '../../jwt-connector/';
import getProfile from "../../services/requests/image";
import { useHistory } from "react-router-dom";
import Loader from "react-js-loader";
import { Notification, KIND } from "baseui/notification";
import DeleteAlt from 'baseui/icon/delete-alt';
import "./styles.css"
import StudentAPI from "services/requests/student_api"
import { useSetState, useTrackedState } from "store/store";
import RolesPermission from "services/requests/rolesPermissions";
import getMenu from "../../components/menu"

export default function SSOHome() {
  const history = useHistory();
  var jwtBuilder = new JWTBuilder();
  const [loader, setloader] = React.useState(true);
  const [errmsg, setErrMsg] = React.useState("");
  const setState = useSetState();
  const state = useTrackedState();

  const role_weight = [
    { label: "linkforce_admin", value: 1 },
    { label: "tenant_owner", value: 2 },
    { label: "rapidascentautomation_manager", value: 3 },
    { label: "linkforce_manager", value: 4 },
    { label: "linkforce_mentor", value: 5 },
    { label: "linkforce_learner", value: 6 },
  ];

  useEffect(() => {
    if(localStorage.getItem("viewAs") === null){
      const queryParams = new URLSearchParams(window.location.search);
      let token = queryParams.get("id_token");
      Login(token); 
    }else{
      loadSectionViewAs();
    }
  },[])

   function verifyingToken (){
    let verified = false;
    verified = jwtBuilder.verifyJwt();
    return verified;
  }

  async function Login(token) {
    const DECODED_CERT = window.atob(process.env.REACT_APP_SSO_CERT_ENCODED)
     //var verified = false;
     // Gets the id_token parameter from the query URL
     let jwt = token
     
    if (jwt) {
      // Initialize the JWT
      jwtBuilder.parseJwt(jwt);
      // set the secret that was shared by your IdP
      jwtBuilder.setSecret(DECODED_CERT);
      try {
        // Compare the hashed jwt with the one received
        if (verifyingToken()) {
          setErrMsg("")
          // Once you find the JWT is verified, you can go ahead and get the data from JWT
          let user = jwtBuilder.getPayload();
          let username = user.first_name+' '+user.last_name;
          let email = user.email;
          userRole(user);
          localStorage.setItem("username",username);
          localStorage.setItem("firstName",user.first_name);
          localStorage.setItem("lastName",user.last_name);
          localStorage.setItem("email",email)
          await rolesPermissions(email);
          await getImage(email);
          //loadSection()
          // You can create a user session here if required and navigate to the home page;
        }
      } catch (error) {
        setErrMsg("Oops! Something went wrong. Please try again!");
        console.error(error);
      }
    }
  };

const rolesPermissions = (userEmail) => {
      RolesPermission(userEmail)
        .then(function (response) {
          if (response.status === 200) {
            localStorage.setItem(
              "rolesPermission",
              JSON.stringify(response.data)
            );
            getMenu();
            setTimeout(() => {
              loadSection()
            }, 3000);
          }       
        })
        .catch((err) => {
          console.log(err);
        });
}

function userRole(user) {
  const myArrayFiltered = role_weight?.filter((el) => {
    return user.groups.some((f) => {
      return f === el.label
    });
  });

  var userVal = myArrayFiltered[0].value
  switch(userVal) {
    case 1:
      localStorage.setItem("role","ADMIN");
      break;
    case 2:
      localStorage.setItem("role","TENANT OWNER");
      break;
    case 3:
      localStorage.setItem("role","MANAGER");
      break;
    case 4:
      localStorage.setItem("role","MANAGER");
      break;
    case 5:
      localStorage.setItem("role","MENTOR");
      break;
    case 6:
      localStorage.setItem("role","LEARNER");
      break;
    default:
      localStorage.setItem("role","LEARNER");
      break;
  }
  //user.groups.includes("tenant_owner") ? localStorage.setItem("role", "TENANT OWNER") : user.groups.includes("linkforce_manager") ? localStorage.setItem("role", "ADMIN") : (user.groups.includes("linkforce_mentor") ? localStorage.setItem("role", "MENTOR") : (user.groups.includes("rapidascentautomation_manager") ? localStorage.setItem("role", "MANAGER") : (user.groups.includes("linkforce_learner") ? localStorage.setItem("role", "LEARNER") : localStorage.setItem("role", "LEARNER"))));
}

function getImage(email) {
    return getProfile(email)
      .then((response) => {
        if (response.status === 200) {
          if (response.data !== "Image Not Found!" && response.data !== '') {
            localStorage.setItem("image", response.data);
          } else {
            localStorage.setItem("image", null);
          }
        }else{
          localStorage.setItem("image", null);
        }
      })
      .catch((err) => {
        setloader(false);
        localStorage.setItem("image", null);
      });
}

const stdentTrack  = async () => {
  try {
  var email_val;
   if(localStorage.getItem("view_as_learner") === null) {
    email_val = localStorage.getItem("email")
   }else{
    email_val = localStorage.getItem("view_as_learner")
   }
  const response = await StudentAPI(email_val,email_val)
  if (response.status === 200 ) {
    const studentOverview = response.data[0]?.learner_profile_list[0];
    localStorage.setItem("learner_data",response.data[0].learner_profile_list.length)
    if(response.data[0].learner_profile_list.length > 0){
      localStorage.setItem("track", studentOverview);  
      setState((prev) => ({ ...prev, track :  studentOverview ,isFetchTrackData: true}),()=>{
        history.push("/tracksummary"); 
      }); 
    }else{
      history.push("/landing");
    }
  }else{
      console.log("somethinh went wrong")
      history.push("/landing");
  }
} catch (e) {
  console.log(e);
  setState((prev) => ({
    ...prev,
    track: {},
    isFetchTrackData: false,
  }));
} 
}

const loadSection = () =>{
  if (localStorage.getItem("role") === "ADMIN" || localStorage.getItem("role") === "TENANT OWNER" || localStorage.getItem("role") === "MANAGER") {
    history.push("/student");
  } else if (localStorage.getItem("role") === "MENTOR"){
    history.push("/student");
  }
  else if (localStorage.getItem("role") === "LEARNER"){
    stdentTrack();
  }
  else{
    history.push("/landing");
  }
}

const loadSectionViewAs = () =>{
  if (localStorage.getItem("viewAs") === "ADMIN" || localStorage.getItem("viewAs") === "TENANT OWNER" || localStorage.getItem("viewAs") === "MANAGER") {
    history.push("/student");
  } else if (localStorage.getItem("viewAs") === "MENTOR"){
    history.push("/student");
  }
  else if (localStorage.getItem("viewAs") === "LEARNER"){
    stdentTrack();
  }
  else if(localStorage.getItem("viewAs") !== null){
    history.push("/landing");
  }
}

return (
    <div className="overview_loginSection">
        {errmsg ? (
        <React.Fragment>
          <Notification overrides={{
        Body: {
          style: ({$theme}) => ({
            position:'absolute',
            top:'5%;',
            right:'0',
            background:'red',
            color:'#fff'
          }),
        }, CloseIcon: {
          component: DeleteAlt,
          style: {float: 'right', cursor: 'pointer'},
        },
      }}
       kind={KIND.negative} closeable>{errmsg}</Notification>
        </React.Fragment>
      ) : null}
       {loader ? (
        <div className="loader-bg">
          <Loader
            type="bubble-loop"
            bgColor={"#FFFFFF"}
            color={"#FFFFFF"}
            size={100}
          />
        </div>
      ) : null}
         <div className="overview_ssohome">
          <div className="brandLogo"></div>
        </div>
    </div>
)};